import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

/**
 * SEO — reusable per-page meta manager (invisibile all'utente).
 * Aggiorna title, description, canonical, OG e Twitter tag lato client.
 * Rimuove eventuali tag canonical/title statici da index.html per evitare duplicati.
 */
export default function SEO({
  title,
  description,
  path = "/",
  image = "https://customer-assets.emergentagent.com/job_process-gap/artifacts/06tz6h9s_Foto%20Profilo.webp",
  type = "website",
  jsonLd,
  noindex = false,
}) {
  const url = `https://robertacastagna.it${path}`;
  const fullTitle = title
    ? `${title} | Roberta Castagna`
    : "Roberta Castagna — Business Consultant & Brand Strategist per Aziende e PMI | Metodo A.L.L.I.N.E.A.";
  const desc =
    description ||
    "Roberta Castagna, Business Consultant e Brand Strategist. Reingegnerizzo processi e brand delle imprese con il Metodo proprietario A.L.L.I.N.E.A.";

  // Rimuove tag statici (da index.html) per evitare duplicati con quelli gestiti da Helmet.
  useEffect(() => {
    document
      .querySelectorAll("link[rel='canonical'][data-default-canonical]")
      .forEach((el) => el.remove());
    document
      .querySelectorAll("meta[name='robots'][data-default-robots]")
      .forEach((el) => el.remove());
  }, []);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex
        ? <meta name="robots" content="noindex, nofollow" />
        : <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:site_name" content="Roberta Castagna" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
